const ErrorMessage = ({ message }) => {
    if (!message) return null;

    return (
        <p className="mt-1 text-xs text-rose-500">{message}</p>
    );
};

export default ErrorMessage;
